import { IColumn } from "@fluentui/react";
import { sendApiRequest } from "../lib/helper";

export interface IItem {
    [x:string]: any;
}

export interface APIPaths {
    getItems: string,
    deleteItem: string,
    addOrUpdateItem: string
}

export interface ICRUDProps { 
    routePath: string, 
    apiPaths: APIPaths, 
    idField: string, 
    columns: IColumn[], 
    friendlyName: string, 
    buildColumns?: boolean, 
    additionalColumns?: IColumn[];
    columnsToFilter?: string[]
}

const API_PREFIX = "/api/sql/"

export const getItems = (apiPath: string, queryString?: string): Promise<any[]> => {
    let additionalPath = queryString ? `?${queryString}` : "";
    return sendApiRequest(`${API_PREFIX}${apiPath}${additionalPath}`, "GET");
};

export const getItem = (apiPath: string, IdField: string, Id: number | string): Promise<any> => {
    return sendApiRequest(`${API_PREFIX}${apiPath}?${IdField}=${encodeURIComponent(Id)}`, "GET");
};

export const updateItem = (apiPath: string, item: IItem): Promise<IItem> => {
    return sendApiRequest(`${API_PREFIX}${apiPath}`, "POST", JSON.stringify({ item: item}));
};

export const deleteItem = (apiPath: string, item: IItem): Promise<IItem> => {
    return sendApiRequest(`${API_PREFIX}${apiPath}`, "DELETE", JSON.stringify({ item: item}));
};